export const environment = {
  production: true,
  teamUrlRedirect: 'https://admin.totalglobalsports.com/TeamAdmin/Dashboard.aspx?tid=',
  //firebaseConfig: {
  //  apiKey: "AIzaSyCrFY0b3twNc0s6f3iu3K-NRWZl12W28_U",
  //  authDomain: "tgs-club-app.firebaseapp.com",
  //  databaseURL: "https://tgs-club-app-default-rtdb.firebaseio.com",
  //  projectId: "tgs-club-app",
  //  storageBucket: "tgs-club-app.appspot.com",
  //  messagingSenderId: "159170957833",
  //  appId: "1:159170957833:web:7da80140e4d044c4811ed8",
  //  measurementId: "G-S8P3ZNVB2F"
  //},
 secretKey: 'secreme_key',
};



// WEBPACK FOOTER //
// ./src/environments/environment.prod.ts